import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { ADD_USER_REQUEST } from "./UserTypes";
import { addUserFailure, addUserSuccess } from "./UserAction";

function* addUserSaga(action) {
  try {
    console.log("Payload:", action.payload);
    const response = yield call(
      axios.post,
      `http://154.61.173.123:7000/auth/register`,
      action.payload
    );
    console.log("Response:", response.data.data);
    yield put(addUserSuccess(response.data.data));
  } catch (error) {
    const errorDetails = error.response?.data || {};
    const errorFields = errorDetails.errorFields || {};
    const additionalErrors = errorDetails.additionalErrors || {};
    const message = errorDetails.message || "Failed to add user";
    yield put(
      addUserFailure({
        message,
        additionalErrors,
        errorFields
      })
    );
  }
}

export default function* userSaga() {
  yield takeLatest(ADD_USER_REQUEST, addUserSaga);
}
